const _regex = /\"/g;

export const validationCsvSameChallengeId = (
  csv: string | ArrayBuffer | null,
  challengeId: string | undefined,
): boolean => {
  console.log(typeof csv);

  if (typeof csv === 'string') {
    // const csvChallengeId = csv
    //   .slice(0, csv.indexOf('\n'))
    //   .split(',')
    //   .map((header) => header.replace(_regex, ''))
    //   .filter((header) => header === 'ChallengeId');
    const csvChallengeId = csv
      .slice(0, csv.indexOf('\n'))
      .split(',')
      .map((header) => header.replace(_regex, ''))
      .indexOf('ChallengeId');
    const firstRow = csv
      .slice(csv.indexOf('\n') + 1)
      .split('\n')[0]
      .split(',')
      .map((header) => header.replace(_regex, ''));

    return true;
  }

  return false;
};
